import React from "react";
import { TextField, FormControlLabel, Switch, Box } from "@mui/material";
import { SettingFieldProps } from "../../Utils/Types";
import { DATA_TYPES } from "../../Utils/Constants";
import styles from "../../Styles/settings.module.css";

export default function SettingField({
  setting,
  value,
  onChange,
}: SettingFieldProps) {
  const handleChange = (newValue: string | number | boolean | object) => {
    onChange(setting.name, newValue);
  };

  const renderField = () => {
    console.log(typeof setting.value);
    switch (typeof setting.value) {
      case DATA_TYPES.STRING:
        return (
          <TextField
            fullWidth
            label={setting.translation}
            value={value as string}
            onChange={(e) => handleChange(e.target.value)}
            variant="outlined"
            className={styles.textField}
            InputProps={{ className: styles.textFieldInput }}
          />
        );

      case DATA_TYPES.NUMBER:
        return (
          <TextField
            fullWidth
            label={setting.translation}
            type="number"
            value={value as number}
            onChange={(e) => handleChange(Number(e.target.value))}
            variant="outlined"
            className={styles.textField}
            InputProps={{ className: styles.textFieldInput }}
          />
        );

      case DATA_TYPES.BOOLEAN:
        return (
          <FormControlLabel
            control={
              <Switch
                checked={value as boolean}
                onChange={(e) => handleChange(e.target.checked)}
                color="primary"
              />
            }
            label={setting.translation}
          />
        );

      case DATA_TYPES.OBJECT:
      default:
        return;
    }
  };

  return renderField() ? (
    <Box className={styles.fieldContainer}>{renderField()}</Box>
  ) : null;
}
